import { render, staticRenderFns } from "./loading-button.component.vue?vue&type=template&id=2eb17a6a&scoped=true&"
import script from "./loading-button.component.vue?vue&type=script&lang=ts&"
export * from "./loading-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./loading-button.component.vue?vue&type=style&index=0&id=2eb17a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb17a6a",
  null
  
)

export default component.exports